import { commonUtilConstants } from "../_constants";

export function assetAttachmentList(state = {}, action) {
  switch (action.type) {
    case commonUtilConstants.ATTACHMENTS_LIST_REQUEST:
      return {
        loading: true,
      };
    case commonUtilConstants.ATTACHMENTS_LIST_SUCCESS:
      return {
        items: action.attachments,
      };
    case commonUtilConstants.ATTACHMENTS_LIST_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function deleteAttachment(state = {}, action) {
  switch (action.type) {
    case commonUtilConstants.ATTACHMENTS_DELETE_REQUEST:
      return {
        loading: true,
      };
    case commonUtilConstants.ATTACHMENTS_DELETE_SUCCESS:
      return {
        items: action.attachments,
      };
    case commonUtilConstants.ATTACHMENTS_DELETE_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}


export function uploadAssetAttachment(state = {}, action) {
  switch (action.type) {
    case commonUtilConstants.UPLOAD_ATTACHMENT_REQUEST:
      return {
        loading: true,
      };
    case commonUtilConstants.UPLOAD_ATTACHMENT_SUCCESS:
      return {
        item: action.attachment,
      };
    case commonUtilConstants.UPLOAD_ATTACHMENT_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function assetHTMLDetails(state = {}, action) {
  switch (action.type) {
    case commonUtilConstants.GET_HTML_DETAILS_REQUEST:
      return {
        loading: true,
      };
    case commonUtilConstants.GET_HTML_DETAILS_SUCCESS:
      return {
        item: action.htmlDetail,
      };
    case commonUtilConstants.GET_HTML_DETAILS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function updateAssetHTMlDetails(state = {}, action) {
  switch (action.type) {
    case commonUtilConstants.UPDATE_HTML_DETAILS_REQUEST:
      return {
        loading: true,
      };
    case commonUtilConstants.UPDATE_HTML_DETAILS_SUCCESS:
      return {
        item: action.htmlDetail,
      };
    case commonUtilConstants.UPDATE_HTML_DETAILS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

